import {createApp} from 'vue'
import DeleteCommentOverlay from './DeleteCommentOverlay'

const el = '[data-content=DeleteCommentOverlay]'

export default function (Store) { 
    // nothing to run 
}